import {ApplicationModel} from '../../models/api/applicationModel';
import {CompanyModel} from '../../models/api/companyModel';
import {deleteAsync} from '../../services/http/http';
import {ListMutation} from '../helpers/listMutation';
import {ResourceTableCommonPageType} from '../helpers/resourceListPagination/resourceListPaginationHelpers';

/*
 * Types.
 */

export type InstalledApplicationListPageType = ResourceTableCommonPageType<ApplicationModel>;

export enum InstalledApplicationMutationsEnum {
  DELETE = 'delete',
}

interface DeleteMutationAction {
  type: InstalledApplicationMutationsEnum.DELETE;
  payload: {
    company: CompanyModel;
    applicationIds: ReadonlyArray<ApplicationModel['id']>;
  };
}

export type InstalledApplicationListMutation = DeleteMutationAction;

/*
 * Mutations.
 */

const deleteInstalledApplicationMutation: ListMutation<
  InstalledApplicationListPageType,
  DeleteMutationAction,
  void
> = {
  mutationKey: InstalledApplicationMutationsEnum.DELETE,

  async runSideEffect(payload) {
    const {company, applicationIds} = payload;

    await deleteAsync(`${company.url}/application_installations_batch`, {
      application_installation_ids: applicationIds,
    });
  },

  runOptimisticUpdate(data, payload) {
    return {
      ...data,
      items: data.items.filter((application) => !payload.applicationIds.includes(application.id)),
    };
  },
};

export const installedApplicationListMutations = [deleteInstalledApplicationMutation] as const;
